// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import InsuranceTwoToneSvg from "@fishx/icons-svg/es/asn/InsuranceTwoTone";
import FishxIcon from '../components/FishxIcon';

var InsuranceTwoTone = function InsuranceTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: InsuranceTwoToneSvg
  }));
};

InsuranceTwoTone.displayName = 'InsuranceTwoTone';
export default React.forwardRef(InsuranceTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/InsuranceTwoTone.js
// module id = 2994
// module chunks = 0